// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class GCMDeviceResource extends Resource {
    basePath: string = 'notifications/device/gcm/';

    objectPath: string = 'notifications/device/gcm/{ident}/';
}
